"use client";

import { makeFunctionReference } from "convex/server";
import { useQuery } from "convex/react";
import { useState } from "react";
import {
  resolveCurrentTenantState,
  type CurrentTenantState,
  type TenantMembershipSummary,
} from "@/core/auth/current-tenant";
import { DEMO_TENANT } from "@/lib/demo-data";

const currentMemberships = makeFunctionReference<"query", Record<string, never>, TenantMembershipSummary[]>(
  "tenants:currentMemberships",
);

export function useCurrentTenant(): CurrentTenantState {
  const memberships = useQuery(currentMemberships, process.env.NEXT_PUBLIC_CONVEX_URL ? {} : "skip");
  const [selectedTenantId] = useState<string | null>(() =>
    typeof window === "undefined" ? null : window.localStorage.getItem("haulbase.selectedTenantId"),
  );

  if (!process.env.NEXT_PUBLIC_CONVEX_URL) {
    return resolveCurrentTenantState({
      memberships: [DEMO_TENANT],
      selectedTenantId: selectedTenantId ?? DEMO_TENANT.tenantId,
    });
  }

  return resolveCurrentTenantState({ memberships, selectedTenantId });
}
